export default __webpack_public_path__ + "bfcc1336c8ab6fae6601d0fdd5d840b5.png";